import React from "react";
import HistorialDePuntos from "./HistorialDePuntos";
import { Link } from "react-router-dom";
import { Auth } from "redux-server-connection";

import mercadopago from "../../assets/mercadopago_logo.png";
import stars from "../../assets/stars.png";
import "./styles.css";


//function getLocalRank(props, loggedUser) {
//  var supervisorId = "";
//  if (loggedUser.type === 1) { // Es un supervisor
//    supervisorId = loggedUser.id;
//  } else if (loggedUser.type === 2 && loggedUser.supervisor ) { // Es un vendedor supervisado
//    supervisorId = loggedUser.supervisor;
//  }
//  
//  var rank = 999;
//  var position = 0;
//  for (var i = 0; i < props.users.length; i++) {
//    var user = props.users[i];
//    if (user.type === 2 && user.supervisor === supervisorId) {
//      position++;
//    }
//    if (user.id === loggedUser.id) {
//      rank = position;
//      break;
//    }
//  }
//  return rank;
//}
function getLocalRank(props, loggedUser) {
  var vendor = loggedUser.vendor;
  
  var rank = 999;
  var position = 0;
  for (var i = 0; i < props.users.length; i++) {
    var user = props.users[i];
    if (user.type === 2 && user.vendor === vendor) {
      position++;
    }
    if (user.id === loggedUser.id) {
      rank = position;
      break;
    }
  }
  return rank;
}

function getGlobalRank(props, loggedUser) {
  var rank = 999;
  for (var i = 0; i < props.users.length; i++) {
    var user = props.users[i];
    if (user.id === loggedUser.id) {
      rank = i+1;
      break;
    }
  }
  return rank;
}

const Render = (props, context) => {
  const user = Auth.getUser();
  const globalRank = getGlobalRank(props, user);
  const localRank = getLocalRank(props, user);

  const TYPES = ["","Supervisor", "Vendedor", "Data Entry", "ADMIN"];

  const LEVELS = ["","Inicial", "Pro", "Superpro"];

  return (
    <div>
      <section className="home backgroundHomeCard" role="main">
        <div className="userProfile mbn pbl">
          <div className="container clearfix">
            <div className="userAvatar">
              {user.avatar && (
                <img
                  src={`${user.avatar.icon}`}
                  alt="Avatar del usuario."
                  className="displayBlock fullWidth mbl"
                />
              )}
              {(user.type === 2) && (
                  <div className="userType number floatLeft goldCircle fontGold avenirBK violet">
                    {globalRank}°
                  </div>
              )}
              <Link to="/avatar" className="btn btnHollow mha">
                Cambiar Personaje
              </Link>
            </div>
            <div className="userData clearfix">
              <div className="data clearfix fullWidth">

                <div className="profile pRel flexColumn fullWidth">
                  <h1 className="displayBlock man avenirBK white horizontalCenter userName">
                    {user.name} {user.surname}
                  </h1>
                  <Link to="/cambiar-pass" className="cambiarContrasena yellow displayBlock horizontalCenter">
                    Cambiar contraseña
                  </Link>
                  <p className="pRel mts avenirM white horizontalCenter mtl">
                    {user.vendor}{" "}
                    <span className="cargo">
                      {TYPES[parseInt(user.type, 10)]}
                    </span>
                  </p>
                  <p className="avenirM white horizontalCenter mts">
                    Nivel:{" "}
                    <span className="upperCase bold">
                      {LEVELS[parseInt(user.level, 10)]}
                    </span>
                  </p>
                  {(user.type === 2) && (
                    <div className="gold pts pbs round mtl">
                    <p className="avenirB mbs fontGold horizontalCenter pts pbs round bold  ">{globalRank}° a Nivel Nacional</p>
                    <div className="lineGold"></div>
                    <p className="avenirB   fontGold horizontalCenter pts pbs round bold">{localRank}° en {user.vendor}{" "}</p>
                    </div>
                  )}
                </div>
              </div>
              <div className="puntos clearfix fullWidth horizontalCenter">
                {(user.type === 1 || user.type === 2 || user.type === 3) && (
                  <div>
                    <img src={stars} alt="Stars" className="mbs bgNone estrellas" />
                    <h1 className="avenirBK white displayBlock fullWidth horizontalCenter line ptl pbl mbn halfWidth">PUNTOS</h1>

                    <p className=" avenirL white displayBlock line horizontalCenter fullWidth pbl ptl line">
                      MES: {" "}
                      <span className="cifra displayInline avenirBK white upperCase horizontalCenter">
                        {user.monthlyPoints} <span className="avenirL">pts</span>
                      </span>
                    </p>

                    <p className=" avenirL white displayBlock horizontalCenter mtl fullWidth">
                      ACUMULADOS: {" "}
                      <span className="cifra displayInline avenirBK white upperCase horizontalCenter">
                        {user.points} <span className="avenirL">pts</span>
                      </span>
                    </p>

                    <div className="avenirL white horizontalCenter mtl halfWidth mbl">
                      <div className="horizontalCenter">
                        <a className="mha" href="https://www.mercadopago.com.ar/activities" target="_blank" rel="noopener noreferrer" style={{height: 55, width: 135}}>
                          <img src={mercadopago} alt="Mercado Pago" height="52"/>
                        </a>
                      </div>                  
                    </div>
                  </div>
                )}

              </div>
            </div>
          </div>
        </div>
      </section>

        {
          (user.type === 1 || user.type === 2 || user.type === 3) && 
  //        (user.type === -1) && 
          props.goals &&
          props.goals.length && (
            <HistorialDePuntos user={user} goals={props.goals} points={props.points} className="mbn"/>
          )
        }
    </div>
  );
};

Render.contextTypes = {};

export default Render;



// WEBPACK FOOTER //
// ./src/pages/Home/Render.js